module.exports = __webpack_public_path__ + "img/thumbnail_arga-yadsan.50029d9b.png";